import { connect } from 'react-redux';
import { flowRight } from 'lodash';
import { InviteDoctorForm as InviteDoctorFormView } from './InviteDoctorForm';
import { inviteDoctorFormSelector } from './selector';
import * as Actions from './actions';
import { withAB } from '../../../../config/ab';
import {
    shouldShowNewSidebar,
    showFindSimilarDoctors,
} from '../../../../config/ab/selector';
import { SHOW_FIND_SIMILAR_DOCTORS } from '../../../../config/ab/experiments';

const mapStateToProps = state => {
    const inviteDoctorFormState = inviteDoctorFormSelector(state);

    return {
        ...inviteDoctorFormState,
        shouldShowNewSidebar: shouldShowNewSidebar(state),
        showFindSimilarDoctors: showFindSimilarDoctors(state),
    };
};

const mapDispatchToProps = {
    onBlurDoctorsEmail: Actions.inputDoctorsEmail,
    onBlurFirstName: Actions.inputFirstName,
    onBlurLastName: Actions.inputLastName,
    onClickSend: Actions.submitForm,
    onClickFindAnotherDoctor: Actions.clickFindAnotherDoctor,
    onClickFindSimilarDoctors: Actions.trackClickFindSimilarDoctors,
    onClickClaimThisProfile: Actions.claimThisProfile,
};

export const InviteDoctorForm = flowRight(
    connect(mapStateToProps, mapDispatchToProps),
    withAB(SHOW_FIND_SIMILAR_DOCTORS),
)(InviteDoctorFormView);
